import React from "react";
import PropTypes from "prop-types";

/**
 * Circular arrows / sync icon (Material Design style).
 * Accepts size, fill, and className for reuse (e.g. with spin animation).
 */
export function SyncIcon({ size = 24, fill = "currentColor", className, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox="0 -960 960 960"
      fill={fill}
      className={className}
      {...rest}
    >
      <path d="M195-302q-28-41-40-85.5T143-480q0-135 98-235t232-100h43l-68-69 47-47 162 163-162 162-48-47 67-68h-39q-97 0-167.5 71.5T237-480q0 32 6.5 60t17.5 52l-66 66ZM463-26 301-188l162-164 48 48-69 68h43q97 0 167.5-71.5T723-478q0-31-6.5-59T698-589l67-66q27 42 39.5 86t12.5 91q0 136-98 236.5T488-141h-46l69 68-48 47Z" />
    </svg>
  );
}

SyncIcon.propTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string
};
